'use strict';

class LindorffAgency {
  constructor(originatorService, invoiceService, Notification) {
    this.originatorService = originatorService;
    this.invoiceService = invoiceService;
    this.Notification = Notification;
  }

  $onInit() {
    this.creditors = [];
    this.requireBirthNumber = false;
    this.creditor = {
      name: this.accountIntegrations.originator.name,
      email: this.accountIntegrations.originator.contact.email,
      city: this.accountIntegrations.originator.contact.address.city,
      phone: this.accountIntegrations.originator.contact.phone,
      description: null,
      organisationNumber: this.accountIntegrations.originator.organisation.number,
      birthNumber: null,
      includeTax: false,
      acceptEula: false,
      collectionAgency: 'LINDORFF'
    };
    this.status = false;
    this.agencies = this.originatorService.collectionAgencies;

    this.I18N = {
      NOT_REGISTERED: 'Under registrering',
      REGISTERED: 'Aktiv',
      CLOSED: 'Deaktivert',
      AWAITING_FIRST_CASE: 'Avventer oversendelse av første sak'
    };

    this.load();
  }

  load() {
    this.originatorService.get()
      .then((resp) => {
        this.requireBirthNumber = resp.data.organisation.form === 'enk';
      });

    this.originatorService.getCreditors()
      .then((resp) => {
        if (resp.data && resp.data.length) {
          this.creditors = resp.data
            .filter((item) => item.collectionAgency === 'LINDORFF')
            .map((item) => {
              if (item.organisationNumber === this.accountIntegrations.originator.organisation.number) {
                this.status = true;
                this.agencies.push('LINDORFF');
              }

              return item;
            });
        }
      });
  }

  register() {
    this.invoiceService.registerCreditor(this.creditor)
      .then(() => {
        this.load();
        //refresh settings
        this.accountIntegrations.settings.defaults.collectionAgency = this.creditor.collectionAgency;
        this.originatorService.getForce();
      });
  }
}

LindorffAgency.$inject = ['originatorService', 'invoiceService', 'Notification'];

const lindorffAgency = {
  controller: LindorffAgency,
  require: {
    accountIntegrations: '^^accountIntegrations'
  },
  template: `
    <fieldset ng-form="registerCreditor_LINDORFF">
      <div class="row">
        <div class="large-3 columns">
          <img src="/assets/img/intrum.png" alt="Intrum" />
        </div>

        <div class="large-9 columns">
          <p>
            SendRegning har integrert seg med <a href="https://www.intrum.no" target="_blank" rel="nofollow">Intrum </a> (tidl. Lindorff) for håndtering av inkassosaker.
          </p>
          <p><span ng-hide="$ctrl.status">Før du kan sende regningen din til inkasso må du inngå en avtale med Intrum ved å fylle inn skjemaet under.</span></p>
          <p>
          Overføring av sak til Intrum koster kr 35,-. I tillegg kommer <a href="https://www.sendregning.no/files/Priser_Intrum.pdf" target="_blank" rel="nofollow">Intrum priser</a>.
          </p>

          <div ng-show="$ctrl.accountIntegrations.settings.defaults.collectionAgency !== 'LINDORFF' && $ctrl.agencies.length > 1">
            <button class="button" ng-click="$ctrl.accountIntegrations.update('LINDORFF')">Send nye saker til Intrum</button>
          </div>

          <p ng-show="$ctrl.accountIntegrations.settings.defaults.collectionAgency === 'LINDORFF' && $ctrl.agencies.length > 1">
            <b>Alle nye inkassosaker vil sendes til Intrum</b>
          </p>

          <div ng-hide="$ctrl.status">
            <h3 class="subheader">Kontaktperson</h3>

            <div>
              <label for="name">Navn</label>
              <input type="text" id="name" name="name" ng-model="$ctrl.creditor.name" placeholder="Ola Nordmann" required>
            </div>

            <div>
              <label for="email">E-postadresse</label>
              <input type="email" id="email" name="email" ng-model="$ctrl.creditor.email" maxlength="64" placeholder="ola@nordmann.no" required>
            </div>

            <div>
              <label for="phone">Telefon</label>
              <input type="tel" id="phone" name="phone" ng-model="$ctrl.creditor.phone" required>
            </div>

            <div>
              <label for="city">By</label>
              <input type="text" id="city" name="city" ng-model="$ctrl.creditor.city" placeholder="OSLO" required>
            </div>

            <div>
              <label for="organisationNumber">Organisasjonsnummer</label>
              <input type="text" id="organisationNumber" name="organisationNumber" ng-model="$ctrl.creditor.organisationNumber" placeholder="123 456 789" organisation-number-validator required>
            </div>

            <div ng-if="$ctrl.requireBirthNumber">
              <label for="birthNumber">Fødselsnummer</label>
              <input type="text" id="birthNumber" name="birthNumber" ng-model="$ctrl.creditor.birthNumber" placeholder="12345678901" birth-number-validator required>
            </div>

            <div>
              <label for="description">Beskriv varen/tjenesten firmaet ditt hovedsakelig selger</label>
              <textarea id="description" name="description" ng-model="$ctrl.creditor.description" required></textarea>
            </div>

            <div>
              <label for="includeTax">
                <input type="checkbox" id="includeTax" name="includeTax" ng-model="$ctrl.creditor.includeTax">
                Er varene/tjenestene firmaet ditt hovedsakelig selger MVA-pliktige?
              </label>
            </div>

            <div>
              <label for="acceptEula">
                <input type="checkbox" id="acceptEula" name="acceptEula" ng-model="$ctrl.creditor.acceptEula" required>
                Jeg godtar <a href="https://www.sendregning.no/files/vilklar_intrum.pdf" target="_blank" rel="nofollow"> vilkårene for bruk</a>
              </label>
            </div>

            <button ng-click="$ctrl.register()" class="button" ng-disabled="registerCreditor_LINDORFF.$invalid">Inngå avtale</button>
          </div>
        </div>
      </div>

      <hr ng-show="$ctrl.creditors.length">

      <table ng-show="$ctrl.creditors.length">
        <thead>
          <tr>
            <th>Kundenummer</th>
            <th>Organisasjonsnummer</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="creditor in $ctrl.creditors track by $index">
            <td>{{ creditor.kNumber }}</td>
            <td>{{ creditor.organisationNumber }}</td>
            <td>{{ $ctrl.I18N[creditor.state] }}</td>
          </tr>
        </tbody>
      </table>
    </fieldset>
  `
};

angular
  .module('SendRegning')
  .component('lindorffAgency', lindorffAgency);
